import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { http, errText } from "@/lib/api";

const STATUSES = ["new", "reviewing", "contacted", "archived"];
const SKIP = new Set(["id", "kind", "status", "created_at", "reference", "notification"]);

export const RequestsTable = () => {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(null);
  const load = useCallback(() => http.get("/admin/requests").then((r) => setItems(Array.isArray(r.data) ? r.data : [])).catch((e) => toast.error(errText(e))), []);
  useEffect(() => { load(); return undefined; }, [load]);
  const setStatus = async (id, status) => {
    try { await http.patch(`/admin/requests/${id}`, { status }); setItems((p) => p.map((x) => (x.id === id ? { ...x, status } : x))); }
    catch (e) { toast.error(errText(e)); }
  };
  if (!items.length) return <p className="p-10 text-center text-[#465F57] bg-white rounded-3xl border border-[#154F49]/15" data-testid="requests-empty">No care or staffing requests yet.</p>;
  return (
    <ul className="space-y-3" data-testid="requests-list">
      {items.map((r) => (
        <li key={r.id} className="bg-white rounded-2xl border border-[#154F49]/15">
          <button type="button" onClick={() => setOpen(open === r.id ? null : r.id)} aria-expanded={open === r.id} className="w-full text-left p-4 flex flex-wrap items-center gap-3 justify-between" data-testid={`request-row-${r.id}`}>
            <span className="flex flex-wrap items-center gap-3">
              <span className={`px-2.5 py-1 rounded-full text-xs font-bold ${r.kind === "care" ? "bg-[#EDF1E6] text-[#154F49]" : "bg-[#CDA34F]/25 text-[#154F49]"}`}>{r.kind === "care" ? "Care" : "Staffing"}</span>
              <span className="font-semibold text-[#154F49]">{r.kind === "care" ? r.name : r.facility}</span>
              <span className="text-xs text-[#465F57]">{r.reference} · {new Date(r.created_at).toLocaleString()}</span>
            </span>
            <span className="text-xs font-bold capitalize text-[#154F49]">{r.status}</span>
          </button>
          {open === r.id && (
            <div className="px-4 pb-4 space-y-3 border-t border-[#154F49]/10 pt-3">
              <dl className="grid sm:grid-cols-2 gap-x-6 gap-y-2 text-sm">
                {Object.entries(r).filter(([k, v]) => !SKIP.has(k) && v).map(([k, v]) => (
                  <div key={k}><dt className="text-xs text-[#465F57] capitalize">{k.replace(/_/g, " ")}</dt><dd className="text-[#1A2E2B] font-medium break-words">{String(v)}</dd></div>
                ))}
              </dl>
              <p className="text-xs text-[#465F57]">Email notification: <strong>{r.notification || "—"}</strong></p>
              <div className="flex flex-wrap gap-2">
                {STATUSES.map((s) => <button key={s} type="button" onClick={() => setStatus(r.id, s)} className={`px-3 py-1.5 rounded-full text-xs font-bold capitalize border ${r.status === s ? "bg-[#154F49] text-[#FBF8F1] border-[#154F49]" : "border-[#154F49]/30 text-[#154F49]"}`}>{s}</button>)}
                <a href={`mailto:${r.email}`} className="btn-ghost text-xs">Email</a>
                <a href={`tel:${r.phone}`} className="btn-ghost text-xs">Call</a>
              </div>
            </div>
          )}
        </li>
      ))}
    </ul>
  );
};
